module.exports = __webpack_public_path__ + "static/media/ic_radio_on.369add70.svg";